import { JobStatus as APIJobStatus } from 'api/domain/entities/Job';

export type JobStatus = APIJobStatus;
export const JobStatus = APIJobStatus;
